import {Avatar, Card, CardContent, styled} from '@mui/material';
import {AlertInfo} from 'presentation/components/AlertInfo';

const UserHealthCardContainer = styled(Card)`
	&.MuiPaper-elevation {
		${({theme}) => theme.breakpoints.down('lg')} {
			margin: -32px -32px 0;
			background: transparent;
			border-radius: 0;
		}

		${({theme}) => theme.breakpoints.down('sm')} {
			margin: -16px -16px 0;
		}
	}
`;

const InitialsAvatar = styled(Avatar)`
	margin-top: -32px;
	width: 64px;
	height: 64px;
	background: ${({theme}) => theme.palette.primary.contrastText};
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.35);
	margin-inline: auto;
`;

const StyledCardContent = styled(CardContent)`
	background-color: ${({theme}) => theme.palette.background.paper};
	border: 1px solid ${({theme}) => theme.palette.divider};
	border-radius: 12px 12px 0 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 16px 16px 12px;
`;

const StyledAlertInfo = styled(AlertInfo.Root)({
	padding: '4px 8px',
	borderRadius: '6px 6px 0 0',

	'& .MuiAlert-icon': {
		padding: 0,
		marginRight: 8,
	},

	'& .MuiAlert-message': {
		paddingTop: 0,
		paddingBottom: 0,
	},
});

export {UserHealthCardContainer, InitialsAvatar, StyledCardContent, StyledAlertInfo};
